module.exports = __webpack_public_path__ + "img/symbol_5.3bf0dc3e.png";